import { useSentryContext } from '@common/context/sentry-context';
import { browserTracingIntegration, captureException, init } from '@sentry/react';
import { useEffect } from 'react';

export const useSentry = () => {
  const sentryContext = useSentryContext();

  const captureError = (
    error: Error,
    context?: Parameters<typeof captureException>[1]
  ) => {
    if (!sentryContext.enabled) {
      return;
    }
    captureException(error, context);
  };

  useEffect(() => {
    if (import.meta.env.VITE_SENTRY_DSN && sentryContext.enabled) {
      init({
        sendDefaultPii: true,
        dsn: import.meta.env.VITE_SENTRY_DSN, // dns key changed due to too many  reuqest error
        integrations: [browserTracingIntegration()],
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0
      });
    }
  }, [sentryContext.enabled]);

  return {
    error: captureError
  };
};
